import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonSecurityInfoComponent from 'webapp/components/common/security-info';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SourceConnectButtonComponent from 'webapp/components/source/connect/button';

import type SourceType from 'webapp/models-custom/source-type';

export default class SourceTypeGroupInfoPopupComponent extends PopupInnerModalComponent<PopupData.Source.SourceTypeInfo> {
	@service('connect') declare connectService: Service.Connect;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('analytics') declare analyticsService: Service.Analytics;

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.analyticsService.event(TrackingEvent.INTEGRATION_POPUP_OPENED, {
			type: this.model.key,
		});
	}

	get model() {
		return this.popupData.model;
	}

	@action
	connect(datasourceType: SourceType): void {
		this.popupData.onConnect(datasourceType);
	}

	@action
	helpConnect(datasourceType: SourceType): void {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		if (this.currentUserService.model?.isVerified) {
			datasourceType.requestConnect();
		} else {
			this.connectService.openEmailVerificationInfoPopup();
		}
	}
	<template>
		<div class="content">

			<div class="header">
				<strong>{{this.model.groupInfo.text1}}</strong>
				<p>{{this.model.groupInfo.text2}}</p>
			</div>

			<div class="items">
				{{#each this.model.groupItems as |groupItem|}}
					<div class="item">
						<div class="item__image">
							<img
								class="avatar avatar--big"
								src={{groupItem.avatarBig}}
								width="185"
								alt
							/>
							<img
								class="avatar avatar--small"
								src={{groupItem.avatar}}
								width="40"
								alt
							/>
						</div>
						<div class="item__info">
							<strong>{{groupItem.name}}</strong>
							<p>{{groupItem.description}}</p>
						</div>
						<div class="item__actions">
							<SourceConnectButtonComponent
								@sourceType={{groupItem}}
								@onConnect={{fn this.connect groupItem}}
								@size="big"
								@noDelay={{true}}
								@extraClass="connect-now next"
								@theme="green"
							/>

							{{#if groupItem.showConnectHelp}}
								<a
									role="button"
									class="connect-help button size-big theme-blue-outlined
										{{unless
											this.currentUserService.model.isVerified
											'disabled'
										}}"
									{{on "click" (fn this.helpConnect groupItem)}}
								>
									<CommonUiIconComponent @name="Mail" @size="sm" />
									Ask teammate to connect
								</a>
							{{/if}}
						</div>
					</div>
				{{/each}}
			</div>

			<CommonSecurityInfoComponent />

		</div>
	</template>
}
